// Phone apps are code-split: each app module loads on first open.
import type { ComponentType } from "preact";

export interface AppDef {
  id: string;
  name: string;
  icon: string;
  color: string;
  load: () => Promise<{ default: ComponentType }>;
}

export const APPS: AppDef[] = [
  { id: "wallet", name: "Wallet", icon: "👛", color: "#4f7cff", load: () => import("./Wallet") },
  { id: "pumpr", name: "Pumpr", icon: "📈", color: "#22c55e", load: () => import("./Pumpr") },
  { id: "mintr", name: "Mintr", icon: "🖼️", color: "#a855f7", load: () => import("./Mintr") },
  { id: "farm", name: "Farm", icon: "🌾", color: "#eab308", load: () => import("./Farm") },
  { id: "chirp", name: "Chirp", icon: "🐦", color: "#38bdf8", load: () => import("./Chirp") },
  { id: "messages", name: "Messages", icon: "💬", color: "#22c55e", load: () => import("./Messages") },
  { id: "cars", name: "Cars", icon: "🚗", color: "#ef4444", load: () => import("./Cars") },
  { id: "houses", name: "Houses", icon: "🏡", color: "#d97706", load: () => import("./Houses") },
  { id: "pets", name: "Pets", icon: "🐾", color: "#fb7185", load: () => import("./Pets") },
  { id: "profile", name: "Profile", icon: "🪪", color: "#f97316", load: () => import("./Profile") },
  { id: "vano", name: "Vano", icon: "🤖", color: "#7c3aed", load: () => import("./Vano") },
  { id: "hackr", name: "Hackr", icon: "🧑‍💻", color: "#16a34a", load: () => import("./Hackr") },
  { id: "events", name: "Events", icon: "🎟️", color: "#db2777", load: () => import("./Events") },
  { id: "gadgets", name: "Gadgets", icon: "📱", color: "#0ea5e9", load: () => import("./Gadgets") },
  { id: "world", name: "World", icon: "🌐", color: "#2563eb", load: () => import("./World") },
  { id: "quests", name: "Quests", icon: "🎯", color: "#ea580c", load: () => import("./Quests") },
  { id: "ranks", name: "Ranks", icon: "🏆", color: "#f59e0b", load: () => import("./Ranks") },
  { id: "map", name: "Map", icon: "🗺️", color: "#0ea5e9", load: () => import("./MapApp") },
  { id: "settings", name: "Settings", icon: "⚙️", color: "#64748b", load: () => import("./Settings") },
];
